module.exports = __webpack_public_path__ + "static/assets/1cbbe42477d3ebf853e4e58a4c586716.svg";